import _ from 'lodash';

const rts = {
  handleAmmend_timestamps: 'handleAmmend_timestamps',
}

/**
 * 
 * @param {object} state 
 * @param {object} action 
 * @returns state
 * @description a sports season consists of multiple collections (teams, matches, rankings, history, scheduleDates, playoffs)
 * 
 */
export const TimestampsReducer = (state, action) => {

  const {
    pathViews,
    _validatedTimestamps
  } = state

  const { type, dispatch } = action

  switch (type) {

    case rts.handleAmmend_timestamps:
      return {
        _validatedTimestamps: {
          ..._validatedTimestamps,
          [`${action.timestampType}Info`]: action.timestamp ? action.timestamp : null
        }
      }

    default:
      return { ...state }
  }
}

export const timestampsHandlers = (dispatch) => {
  return {
    handleAmmend_timestamps: (timestampType, timestamp) => { dispatch({ type: rts.handleAmmend_timestamps, dispatch, timestampType, timestamp }) },
  }
}

export const timestampsInitialState = (init_state) => {
  return { ...init_state, _validatedTimestamps: {} }
};